
export const pageNotFoundEmits = () => ([
  "showShops"
])

export const usePageNotFound = (context) => {
  const doMyShoppingLink = "/faire_mes_courses-c-176362"
  const coursesListLink = "/mon-compte/mes-listes-de-courses"

  const showShops = () => {
    context.emit('showShops')
  }

  return {
    doMyShoppingLink,
    coursesListLink,
    showShops
  }
}